import React from 'react';
import AddNote from './AddNote';
import AddPhone from "./Phones/AddPhone"
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  divider: {
    margin: theme.spacing(1, 0),
  },
}));

function CustomerFormCard(props) {
  const classes = useStyles();
  return (
    <>
      <AddNote />
      <AddPhone />
    </>
  );
}

export default CustomerFormCard;
